import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import ReactGA from "react-ga4";

import { RoutedContent } from "../../Routes/index.js";
import FloatingWhatsApp from "../../Components/Common/floatingWhatsApp.js";
import ScrollToTop from "../../Components/Common/scrollToTop.js";
import usePageTracking from "../../Components/Common/usePageTracking.js";

import "./App.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

ReactGA.initialize("G-N8JN926040");

const basePath = process.env.BASE_PATH || "/";

const App = () => {
  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary: "#ffd600", fontFamily: "Inter, sans-serif" },
      }}
    >
      <Router basename={basePath}>
        <FloatingWhatsApp />

        <ScrollToTop />

        <PageTracker />

        <RoutedContent />
      </Router>
    </ConfigProvider>
  );
};

const PageTracker = () => {
  usePageTracking();

  return null;
};

export default App;
